/**
 * dev by fay
 */
import $ from '@ali/tarzan-zepto';

export default class PullLoading {

  init(cont) {
    this.$container = $(cont).find('.avatar-wrap');
    this.$tie = this.$container.find('.avatar-tie');
  }

  __transform($ele, arg) {
    const vendors = ['t', '-webkit-', '-Moz-', '-ms-', '-O-'];
    let transform;
    let i = 0;
    const l = vendors.length;
    for (; i < l; i += 1) {
      transform = `${vendors[i]}ransform`;
      $ele.css(transform, arg);
    }
  }

  setDis(dis) {
    this.__transform(this.$container, `translate(0,${dis < 12 ? dis : 12}px )`);
    this.__transform(this.$tie, `translate(0,${dis < 6 ? dis : 6}px) rotate(${dis < 12 ? (-dis) : -12}deg)`);
    if (dis > 20) {
      this.$tie.addClass('loading');
    }
  }

  clearLoading() {
    this.$tie.removeClass('loading');
  }

}



// WEBPACK FOOTER //
// ./src/component/view/head/pulloading.js